import type { CrmMessages } from "./englishCrmMessages";

// [hiperautomacao] Brazilian Portuguese catalog for the CRM screens.
export const portugueseCrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nome da empresa",
        website: "Site",
        linkedin_url: "LinkedIn",
        phone_number: "Telefone",
        created_at: "Criada em",
        nb_contacts: "Número de contatos",
        revenue: "Faturamento",
        sector: "Setor",
        size: "Porte",
        tax_identifier: "CNPJ",
        address: "Endereço",
        city: "Cidade",
        zipcode: "CEP",
        state_abbr: "UF",
        country: "País",
        description: "Descrição",
        context_links: "Links de contexto",
        sales_id: "Responsável",
      },
      empty: {
        description: "Ainda não há empresas cadastradas.",
        title: "Nenhuma empresa encontrada",
      },
      import: {
        title: "Importar empresas",
      },
      field_categories: {
        contact: "Contato",
        additional_info: "Informações adicionais",
        address: "Endereço",
        context: "Contexto",
      },
      action: {
        create: "Criar empresa",
        edit: "Editar empresa",
        new: "Nova empresa",
        show: "Ver empresa",
      },
      added_on: "Cadastrada em %{date}",
      followed_by: "Acompanhada por %{name}",
      followed_by_you: "Acompanhada por você",
      no_contacts: "Nenhum contato",
      nb_contacts: "%{smart_count} contato |||| %{smart_count} contatos",
      nb_deals: "%{smart_count} negócio |||| %{smart_count} negócios",
      sizes: {
        one_employee: "1 funcionário",
        two_to_nine_employees: "2 a 9 funcionários",
        ten_to_forty_nine_employees: "10 a 49 funcionários",
        fifty_to_two_hundred_forty_nine_employees: "50 a 249 funcionários",
        two_hundred_fifty_or_more_employees: "250 ou mais funcionários",
      },
      autocomplete: {
        create_error: "Não foi possível criar a empresa",
        create_item: "Criar %{item}",
        create_label: "Comece a digitar para criar uma empresa",
      },
    },
    contacts: {
      name: "Contato |||| Contatos",
      forcedCaseName: "Contato",
      field_categories: {
        background_info: "Histórico",
        identity: "Identificação",
        misc: "Outros",
        personal_info: "Contato",
        position: "Cargo",
      },
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        last_seen: "Última atividade",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "E-mails",
        email: "E-mail",
        phone_jsonb: "Telefones",
        phone_number: "Telefone",
        linkedin_url: "LinkedIn",
        background: "Histórico (como chegou, o que procura, etc.)",
        has_newsletter: "Recebe newsletter",
        sales_id: "Responsável",
      },
      action: {
        add: "Adicionar contato",
        add_first: "Adicione o primeiro contato",
        create: "Criar contato",
        edit: "Editar contato",
        export_vcard: "Exportar vCard",
        new: "Novo contato",
        show: "Ver contato",
      },
      background: {
        last_activity_on: "Última atividade em %{date}",
        added_on: "Cadastrado em %{date}",
        followed_by: "Acompanhado por %{name}",
        followed_by_you: "Acompanhado por você",
        status_none: "Nenhum",
      },
      position_at: "%{title} em",
      position_at_company: "%{title} em %{company}",
      empty: {
        description: "Ainda não há contatos cadastrados.",
        title: "Nenhum contato encontrado",
      },
      import: {
        title: "Importar contatos",
      },
      inputs: {
        genders: {
          male: "Ele",
          female: "Ela",
          nonbinary: "Elu",
        },
        personal_info_types: {
          work: "Trabalho",
          home: "Pessoal",
          other: "Outro",
        },
      },
      list: {
        error_loading: "Erro ao carregar os contatos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Voltar às etiquetas",
        create_description:
          "Crie uma etiqueta e aplique aos contatos selecionados.",
        description:
          "Escolha uma etiqueta existente ou crie uma nova para os contatos selecionados.",
        empty:
          "Ainda não há etiquetas. Crie uma para marcar os contatos selecionados.",
        error: "Não foi possível etiquetar os contatos",
        removed:
          "Etiqueta removida de %{smart_count} contato |||| Etiqueta removida de %{smart_count} contatos",
        success:
          "Etiqueta aplicada a %{smart_count} contato |||| Etiqueta aplicada a %{smart_count} contatos",
        title: "Etiquetar contatos",
      },
      merge: {
        action: "Juntar com outro contato",
        confirm: "Juntar contatos",
        current_contact: "Contato atual (será apagado)",
        description: "Juntar este contato com outro.",
        error: "Não foi possível juntar os contatos",
        merging: "Juntando...",
        no_additional_data: "Nada a mais para juntar",
        select_target: "Escolha o contato com que juntar",
        success: "Contatos juntados",
        target_contact: "Contato que fica",
        title: "Juntar contato",
        warning_description:
          "Todos os dados passam para o segundo contato. Não dá para desfazer.",
        warning_title: "Atenção: operação definitiva",
        what_will_be_merged: "O que será juntado:",
      },
      filters: {
        before_last_month: "Antes do mês passado",
        before_this_month: "Antes deste mês",
        before_this_week: "Antes desta semana",
        managed_by_me: "Sob minha responsabilidade",
        search: "Buscar nome, empresa...",
        this_week: "Esta semana",
        today: "Hoje",
        tags: "Etiquetas",
        tasks: "Tarefas",
      },
      hot: {
        empty_change_status:
          'Mude o status de um contato adicionando uma nota e clicando em "mostrar opções".',
        empty_hint: 'Contatos com status "quente" aparecem aqui.',
        title: "Contatos quentes",
      },
    },
    deals: {
      name: "Negócio |||| Negócios",
      fields: {
        name: "Nome",
        description: "Descrição",
        company_id: "Empresa",
        contact_ids: "Contatos",
        category: "Categoria (degrau da oferta)",
        amount: "Valor",
        expected_closing_date: "Previsão de fechamento",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Voltar ao negócio",
        create: "Criar negócio",
        new: "Novo negócio",
      },
      field_categories: {
        misc: "Outros",
      },
      filters: {
        only_mine: "Só os meus negócios",
      },
      archived: {
        action: "Arquivar",
        error: "Erro: o negócio não foi arquivado",
        list_title: "Negócios arquivados",
        success: "Negócio arquivado",
        title: "Negócio arquivado",
        view: "Ver negócios arquivados",
      },
      inputs: {
        linked_to: "Ligado a",
      },
      unarchived: {
        action: "Devolver ao funil",
        error: "Erro: o negócio não voltou ao funil",
        success: "Negócio de volta ao funil",
      },
      updated: "Negócio atualizado",
      empty: {
        before_create: "antes de criar um negócio.",
        description: "Ainda não há negócios.",
        title: "Nenhum negócio encontrado",
      },
      import: {
        title: "Importar negócios",
      },
      invalid_date: "Data inválida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Status",
        date: "Data",
        attachments: "Anexos",
        contact_id: "Contato",
        deal_id: "Negócio",
      },
      action: {
        add: "Adicionar nota",
        add_first: "Adicione a primeira nota",
        delete: "Apagar nota",
        edit: "Editar nota",
        update: "Atualizar nota",
        add_this: "Adicionar esta nota",
      },
      sheet: {
        create: "Nova nota",
        create_for: "Nova nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota de %{name}",
      },
      deleted: "Nota apagada",
      empty: "Ainda não há notas",
      author_added: "%{name} adicionou uma nota",
      you_added: "Você adicionou uma nota",
      me: "Eu",
      list: {
        error_loading: "Erro ao carregar as notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Abra um contato e adicione uma nota",
      },
      added: "Nota adicionada",
      inputs: {
        add_note: "Escreva uma nota",
        options_hint: "(mudar detalhes)",
        show_options: "Mostrar opções",
      },
      actions: {
        attach_document: "Anexar documento",
      },
      validation: {
        note_or_attachment_required: "Escreva a nota",
      },
    },
    sales: {
      name: "Vendedor |||| Vendedores",
      fields: {
        first_name: "Nome",
        last_name: "Sobrenome",
        email: "E-mail",
        secondary_email: "E-mail secundário",
        secondary_emails: "E-mails secundários",
        administrator: "Administrador",
        disabled: "Desativado",
      },
      create: {
        error: "Não foi possível criar o vendedor.",
        success: "Vendedor criado.",
        title: "Novo vendedor",
      },
      edit: {
        error: "Algo deu errado. Tente de novo.",
        record_not_found: "Registro não encontrado",
        success: "Vendedor atualizado",
        title: "Editar %{name}",
      },
      action: {
        new: "Novo vendedor",
      },
    },
    tasks: {
      name: "Tarefa |||| Tarefas",
      forcedCaseName: "Tarefa",
      fields: {
        text: "Descrição",
        due_date: "Prazo",
        type: "Tipo",
        contact_id: "Contato",
        due_short: "até",
      },
      action: {
        add: "Adicionar tarefa",
        create: "Criar tarefa",
        edit: "Editar tarefa",
      },
      actions: {
        postpone_next_week: "Adiar para a próxima semana",
        postpone_tomorrow: "Adiar para amanhã",
        title: "ações da tarefa",
      },
      added: "Tarefa adicionada",
      deleted: "Tarefa apagada",
      dialog: {
        create: "Nova tarefa",
        create_for: "Nova tarefa para %{name}",
      },
      sheet: {
        edit: "Editar tarefa",
        edit_for: "Editar tarefa de %{name}",
      },
      empty: "Ainda não há tarefas",
      empty_list_hint: "As tarefas dos seus contatos aparecem aqui.",
      filters: {
        later: "Depois",
        overdue: "Atrasadas",
        this_week: "Esta semana",
        today: "Hoje",
        tomorrow: "Amanhã",
        with_pending: "Com tarefas pendentes",
      },
      regarding_contact: "(Sobre: %{name})",
      updated: "Tarefa atualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Adicionar etiqueta",
        create: "Criar etiqueta",
      },
      dialog: {
        color: "Cor",
        create_title: "Nova etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nome da etiqueta",
        name_placeholder: "Digite o nome",
      },
      empty: "Ainda não há etiquetas.",
    },
  },
  crm: {
    action: {
      reset_password: "Redefinir senha",
    },
    auth: {
      first_name: "Nome",
      last_name: "Sobrenome",
      confirm_password: "Confirme a senha",
      confirmation_required:
        "Abra o link que enviamos por e-mail para confirmar a sua conta.",
      recovery_email_sent:
        "Se este e-mail estiver cadastrado, você vai receber em instantes a mensagem para criar uma nova senha.",
      sign_in_failed: "Não foi possível entrar.",
      sign_in_google_workspace: "Entrar com Google Workspace",
      signup: {
        create_account: "Criar conta",
        create_first_user:
          "Crie o primeiro usuário para concluir a instalação.",
        creating: "Criando...",
        initial_user_created: "Primeiro usuário criado",
      },
      welcome_title: "Bem-vindo ao CRM",
    },
    common: {
      account_manager: "Responsável",
      activity: "Atividade",
      added: "adicionou",
      details: "Detalhes",
      last_activity_with_date: "última atividade %{date}",
      load_more: "Carregar mais",
      misc: "Outros",
      past: "Passadas",
      read_more: "Ler mais",
      retry: "Tentar de novo",
      show_less: "Mostrar menos",
      copied: "Copiado!",
      copy: "Copiar",
      loading: "Carregando...",
      me: "Eu",
      task_count: "%{smart_count} tarefa |||| %{smart_count} tarefas",
    },
    changelog: {
      title: "Novidades",
    },
    activity: {
      added_company: "%{name} cadastrou a empresa",
      you_added_company: "Você cadastrou a empresa",
      added_contact: "%{name} cadastrou",
      you_added_contact: "Você cadastrou",
      added_note: "%{name} anotou sobre",
      you_added_note: "Você anotou sobre",
      added_note_about_deal: "%{name} anotou sobre o negócio",
      you_added_note_about_deal: "Você anotou sobre o negócio",
      added_deal: "%{name} criou o negócio",
      you_added_deal: "Você criou o negócio",
      at_company: "em",
      to: "em",
      load_more: "Carregar mais atividade",
    },
    dashboard: {
      deals_chart: "Receita prevista dos negócios",
      deals_pipeline: "Funil de negócios",
      latest_activity: "Atividade recente",
      latest_activity_error: "Erro ao carregar a atividade recente",
      latest_notes: "Minhas últimas notas",
      latest_notes_added_ago: "há %{timeAgo}",
      stepper: {
        install: "Instalar o CRM",
        progress: "%{step}/3 feitos",
        whats_next: "Próximos passos",
      },
      upcoming_tasks: "Próximas tarefas",
    },
    data_import: {
      button: "Importar CSV",
      complete:
        "Importação concluída: %{importCount} registros, %{errorCount} erros",
      csv_file: "Arquivo CSV",
      error: "Não foi possível importar. Confira se o arquivo é um CSV válido.",
      in_progress: "Importando…",
      progress:
        "Importados %{importCount} de %{rowCount} registros, com %{errorCount} erros.",
      remaining_time: "Tempo restante estimado:",
      resource: "Tipo de registro",
      sample_download: "Baixar CSV de exemplo",
      sample_hint: "Use este CSV de exemplo como modelo",
      start: "Começar importação",
      stop: "Parar importação",
      stopped:
        "Importação interrompida: %{importCount} registros, %{errorCount} erros",
      title: "Importar dados",
    },
    header: {
      import_data: "Importar de JSON",
    },
    search: {
      title: "Buscar",
      placeholder: "Buscar contatos, empresas, negócios, tarefas e notas...",
      hint: "Digite pelo menos %{min} letras",
      empty: "Nada encontrado",
      error: "A busca está indisponível agora. Tente de novo.",
      untitled_result: "(sem título)",
      groups: {
        contacts: "Contatos",
        companies: "Empresas",
        deals: "Negócios",
        tasks: "Tarefas",
        contact_notes: "Notas de contatos",
        deal_notes: "Notas de negócios",
      },
    },
    image_editor: {
      change: "Trocar",
      drop_hint: "Solte um arquivo aqui ou clique para escolher.",
      editable_content: "Conteúdo editável",
      title: "Enviar e ajustar imagem",
      update_image: "Atualizar imagem",
    },
    import: {
      action: {
        download_error_report: "Baixar o relatório de erros",
        import: "Importar",
        import_another: "Importar outro arquivo",
      },
      error: {
        unable: "Não foi possível importar este arquivo.",
      },
      idle: {
        description_1:
          "Dá para importar vendedores, empresas, contatos, notas e tarefas.",
        description_2: "O arquivo JSON precisa seguir este exemplo:",
      },
      status: {
        all_success: "Todos os registros foram importados.",
        complete: "Importação concluída.",
        failed: "Falhou",
        imported: "Importado",
        in_progress: "Importando, não saia desta página.",
        some_failed: "Alguns registros não foram importados.",
        table_caption: "Situação da importação",
      },
      title: "Importar de JSON",
    },
    settings: {
      about: "Sobre",
      companies: {
        sectors: "Setores",
      },
      dark_mode_logo: "Logo no modo escuro",
      deals: {
        categories: "Categorias",
        currency: "Moeda",
        pipeline_help: "Quais etapas contam como negócio fechado.",
        pipeline_statuses: "Etapas de fechamento",
        stages: "Etapas",
      },
      light_mode_logo: "Logo no modo claro",
      notes: {
        statuses: "Status",
      },
      reset_defaults: "Voltar ao padrão",
      save_error: "Não foi possível salvar a configuração",
      saved: "Configuração salva",
      saving: "Salvando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferências",
      title: "Configurações",
      app_title: "Nome do aplicativo",
      sections: {
        branding: "Marca",
      },
      validation: {
        duplicate: "%{display_name} repetidos: %{items}",
        in_use:
          "Não dá para remover %{display_name} ainda usados em negócios: %{items}",
        validating: "Conferindo…",
        entities: {
          categories: "categorias",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Escuro",
      label: "Tema",
      light: "Claro",
      system: "Do sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegação do CRM",
    },
    profile: {
      add_secondary_email: "Adicionar e-mail",
      email_taken: "%{email} já é usado por outro usuário",
      no_secondary_emails: "Nenhum",
      secondary_email_invalid: "%{email} não é um e-mail válido",
      secondary_email_is_primary: "%{email} já é o seu e-mail principal",
      secondary_email_taken: "%{email} já é usado por outro usuário",
      too_many_secondary_emails: "No máximo 10 e-mails secundários",
      secondary_emails_help:
        "Outros endereços de onde você envia e-mails. Deixe vazio para remover.",
      inbound: {
        description:
          "Envie e-mails para o endereço de entrada do servidor (por exemplo, no campo %{field}) e o CRM transforma em notas nos contatos.",
        title: "E-mail de entrada",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Use este endereço para ligar um assistente de IA aos dados do CRM.",
      },
      password: {
        change: "Trocar senha",
      },
      password_reset_sent:
        "Enviamos para o seu e-mail a mensagem para criar uma nova senha",
      record_not_found: "Registro não encontrado",
      title: "Perfil",
      updated: "Perfil atualizado",
      update_error: "Algo deu errado. Tente de novo",
    },
    validation: {
      invalid_url: "Precisa ser um endereço válido",
      invalid_linkedin_url: "O endereço precisa ser do linkedin.com",
    },
  },
} satisfies CrmMessages;
